<template>
  <div class="section-main__warp points">
    <ioc-table
      ref="crud"
      :data="tableList"
      :option="option"
      :page="page"
      @search-change="getList"
      @search-reset="getList"
      @size-change="sizeChange"
      @current-change="pageChange"
      @selection-change="handleSelectionChange"
    >
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="详情"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            @click="handleUpdate('view', scope.row)"
            icon="iconfont icon-Detail"
          >
          </el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="修改"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-xiugai"
            @click="handleUpdate('edit', scope.row)"
          >
          </el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="删除"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button type="text" icon="el-icon-delete" @click="handleDel(scope.row)">
          </el-button>
        </el-tooltip>
      </template>
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          class="iss-operation-button"
          icon="el-icon-plus"
          @click="handleUpdate('add')"
        >
          新增
        </el-button>
        <el-button
          @click="handleBatchDelete"
          type="primary"
          size="small"
          icon="el-icon-delete"
          class="iss-operation-button"
        >
          批量删除
        </el-button>
      </template>
    </ioc-table>

    <AppPanel
      class="app-panel"
      :isExpand="showDialog"
      @cancel="handleCloseDialog"
      :title="
        pageStates == 'add'
          ? '新增巡更点'
          : pageStates == 'edit'
          ? '编辑巡更点'
          : '巡更点详情'
      "
    >
      <addPoints
        ref="refAddPoints"
        :pageStates="pageStates"
        @updateTable="getListData"
        :pointsInfo="pointsInfo"
      />
      <span slot="footer">
        <el-button @click="handleCloseDialog" :loading="subLoading">取 消</el-button>
        <el-button
          type="primary"
          @click="subDialog"
          :loading="subLoading"
          v-if="pageStates != 'view'"
          >{{ subLoading ? "提交中" : "确定" }}</el-button
        >
      </span>
    </AppPanel>
  </div>
</template>
<script>
import AppPanel from "@src/components/business/app-panel/index.vue";
import { api } from "../api";
import utils from "@src/common/utils";
import tableOption from "../const/table";
import addPoints from "../components/addPoints.vue";
export default {
  components: {
    addPoints,
    AppPanel,
  },
  data() {
    return {
      pointsInfo: {},
      subLoading: false,
      showDialog: false,
      checkIdList: [], //删除集合
      typeList: [
        {
          label: "GPS",
          value: 0,
        },
        {
          label: "二维码",
          value: 1,
        },
        // {
        //   label: "NFC",
        //   value: 2,
        // },
      ],
      pageStates: "add",
      tableList: [],
      option: tableOption(this),
      searchForm: {},
      page: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
    };
  },
  created() {
    this.getListData();
  },
  methods: {
    handleCloseDialog() {
      this.showDialog = false;
      this.$refs.refAddPoints.handleCloseDialog();
    },
    subDialog() {
      console.log("提交");
      this.$refs.refAddPoints.subDialog();
      // this.showDialog = false;
    },
    handleSelectionChange(items) {
      console.log(items);
      this.checkIdList = items.map((el) => {
        return el.pointCode;
      });
    },
    handleBatchDelete() {
      if (!this.checkIdList.length) {
        this.$message.warning("请选择要删除的巡更点");
        return;
      }
      let params = {
        pointCodes: [...this.checkIdList],
      };
      this.$confirm("您确认删除改巡更点位吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.batchDeleteResPoint, params)
          .then((response) => {
            if (response.success) {
              this.checkIdList = [];
              this.$message.success(response.msgContent || "操作成功");
              this.getListData();
            } else {
              this.$message.error(response.msgContent || "操作失败");
            }
          })
          .catch(() => {});
      });
    },
    handleDel(row) {
      let params = {
        pointCode: row.pointCode,
      };
      this.$confirm("您确认删除改巡更点位吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.deleteResPoint, params)
          .then((response) => {
            if (response.success) {
              this.$message.success(response.msgContent || "操作成功");
              this.getListData();
            } else {
              this.$message.error(response.msgContent || "操作失败");
            }
          })
          .catch(() => {});
      });
    },
    handleUpdate(type, row) {
      this.pointsInfo = { ...row };
      this.pageStates = type;
      this.showDialog = true;
    },
    getList(params) {
      this.page.pageNum = 1;
      this.searchForm = Object.assign({}, params);
      this.getListData();
    },
    getListData() {
      this.showDialog = false;
      let params = {
        ...this.searchForm,
        ...this.page,
      };
      delete params.total;
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.queryResPointPage, params).then((res) => {
        loading.close();
        if (res.success) {
          this.page.total = res.returnObj.total;
          this.tableList = res.returnObj.list;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.page.pageNum = 1;
      this.getListData();
    },
    pageChange(pageNo) {
      this.page.pageNum = pageNo;
      this.getListData();
    },
  },
};
</script>
